import $ from 'jquery';
import ScrollMagic from 'scrollmagic';
export default class AbsSection {
    constructor(_containerID, _scrollMagicCon) {
        this.myID = _containerID;
        this.con = $(_containerID);

        this.sc = new ScrollMagic.Scene({
            triggerElement: this.myID,
            offset: 0, // -200,
            duration: this.con.height() // + 400
        });
        this.sc.addTo(_scrollMagicCon);

        this.sc.on('enter leave', event => {
            if (event.type === 'enter') {
                this.animationIn();
            }

            if (event.type === 'leave') {
                this.animationOut();
            }
        });
    }

    getHeight() {
        const _ = this;
        return _.$wrap.height();
    }

    resize(evt) {
        // override
    }
}